import React from 'react';
import { copyFor } from 'config';
import { Text } from '@perch-labs/shrike';
import { Container } from 'styles';
import {
  ContentContainer,
  ExclamationIcon,
  IconContainer,
  Wrapper,
} from './enrollment-timeline.style';

const getCopy = copyFor('solar.enrollmentTimeline.available');

export const EnrollmentTimelineAvailable = () => (
  <Wrapper>
    <Container flex>
      <IconContainer>
        <ExclamationIcon />
      </IconContainer>
      <ContentContainer>
        <Text tag="h2" textStyle="heading700">
          {getCopy('title')}
        </Text>
        <Text textStyle="paragraph400">{getCopy('subTitle')}</Text>
      </ContentContainer>
    </Container>
  </Wrapper>
);
